import React from 'react'
import commonNetwork from '../api/commonNetwork';
import { formatCurrency } from '../../lib/helpers';
import { getStatusDescHelper } from './getStatusDescHelper';
import { getSendTypeDescHelper } from './getSendTypeDescHelper';
import { getCardOwnerAllDescHelper } from './getCardOwnerAllDescHelper';
import { ApiResponseType } from '../api/apiHelper';
import { toast } from 'react-toastify';
import { errorMessages } from '../../constants/messages/errorMessages';
import getUserTypeName from '../../features/components/TableUserTypeView';

export async function exportExcelHelper(data: any, primaryKey: string, tableSelectedRows: React.RefObject<any>, headCells: any, fileName: string) {

    const selecteds = tableSelectedRows.current.getSelectedRows();

    if (selecteds.length > 0) {
        let excelList: any = [];
        let columnWidth = [];
        let withoutExcel = headCells.filter(function (el: any) {
            return el.exceptToExcel != true
        });
        for (let i = 0; i < selecteds.length; i++) {
            excelList.push({});
            const element = selecteds[i];
            let itemindex = data.findIndex((w: any) => w[primaryKey] == element);
            let item = data[itemindex];

            for (let j = 0; j < withoutExcel.length; j++) {
                const element2 = withoutExcel[j];

                let value = item[element2.id];
                // if (element2.alternativeValue) {
                //     value = item[element2.id] || item[element2.alternativeValue];
                // }

                switch (element2.id) {
                    case "orderStatus":
                        const { desc } = getStatusDescHelper(item.orderStatus, item.transactionType);
                        value = desc;
                        break;
                    case "sendTypeId":
                        value = getSendTypeDescHelper(item.sendTypeId);
                        break;
                    case "installment":
                        value = (item.installment === 0 || item.installment === 1 || item.installment === null) ? "Peşin" : item.installment + " Taksit";
                        break;
                    case "taxCode":
                        value = item.taxCode || item.tcCode;
                        break;
                    case "cardOwner":
                        value = getCardOwnerAllDescHelper(item);
                        break;
                    case "status":
                        value = item.status ? "Aktif" : "Pasif";
                        break;
                    case "status":
                        value = item.status ? "Aktif" : "Pasif";
                        break;
                    case "cardMask":
                        value = item.cardBank + "*******" + item.cardMask;
                        break;
                    case "netAmount":
                        value = formatCurrency(item.firstAmount - item.commissionAmount);
                        break;
                    case "nameOnCard":
                        value = item.firstName + " " + item.lastName;
                        break;
                    case "currencySymbol":
                        value = item.currencySymbol === "₺" ? "TL (₺)" : item.currencySymbol === "€" ? "EURO (€)" : item.currencySymbol === "£" ? "GBP (£)" : "USD ($)"
                        break;
                    case "userType":
                        value = item.userType === 1 ? "Firma Yetkilisi" : item.userType === 2 ? "Müşteri Temsilcisi" : item.userType === 3 ? "Bayi / Müşteri" : item.userType === 4 ? "Altbayi" : ""
                        break;
                    case "customerUserList":
                        const users = item.customerUserList;
                        if (Array.isArray(users)) {
                            value = users.join(', '); 
                        } else {
                            value = ''; 
                        }
                        break;
                    default:
                        value = item[element2.id];
                        break;
                }

                if (element2.isMoney) {
                    value = formatCurrency(value);
                }
                if (withoutExcel.length >= columnWidth.length) {
                    columnWidth.push({
                        width: element2.colWidth
                    });
                }

                excelList[i][element2.label] = value;
            }
        }

        const nowDate = new Date();
        const datestr = nowDate.getDate() + "_" + (nowDate.getMonth() + 1) + "_" + nowDate.getFullYear() + "-" + fileName;

        let result: ApiResponseType;

        try {
            result = await commonNetwork.post("/Export/excel", excelList, true);

            const href = URL.createObjectURL(result.data);

            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', datestr + ".xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(href);

            tableSelectedRows.current.clearSelected();
        } catch (error) {
            toast.error(errorMessages.anError + error);
        }
    } else {
        toast.error("Excel dosyası için en az bir kaydın seçili olması gerekmektedir.")
    }
}